import { Component, HostBinding, Inject } from '@angular/core';
import { GoogleAnalyticService, WINDOW } from '@services';
import { Unsubscriber } from '@shared';
import { DonateButtonConfig } from './donate-button.config';

const componentName: string = 'app-donate-button';

@Component({
  selector: 'app-donate-button',
  templateUrl: './donate-button.component.html',
  styleUrls: ['./donate-button.component.scss'],
})
export class DonateButtonComponent extends Unsubscriber {
  readonly DonateButtonConfig = DonateButtonConfig;
  @HostBinding('class.hidden') isHidden: boolean = DonateButtonConfig.isHidden;

  constructor(
    @Inject(WINDOW) private window: Window,
    private googleAnalyticsService: GoogleAnalyticService,
  ) {
    super();
  }

  donate(): void {
    this.window.open(DonateButtonConfig.link, DonateButtonConfig.target);
    this.track();
  }

  private track(): void {
    this.googleAnalyticsService.track(
      'analitics',
      `${componentName}.donate`,
      {
        eventLabel: `Задонать – прокачай ППО!`,
        eventCategory: `${componentName}`,
        eventAction: 'click',
      },
    );
  }
}
